import { NavigationElement, NavigationGroup } from './';

export function isNavigationGroup(
  item: NavigationElement
): item is NavigationGroup {
  return typeof (item as any).items === 'object';
}
